import { JoinPageLayout } from "./JoinPageLayout";

export function JoinUsPage() {
  return (
    <JoinPageLayout
      eyebrow="在山與海之間工作"
      title="一起生活，一起工作。"
      subtitle="JOIN OUR TEAM"
    >
      <p>
        我們希望小星不只是一個睡覺的地方，而是一個能讓人療癒、連結、感到自在的空間。這份工作需要認真照顧環境，也真誠地接住每一位來到這裡的旅人。
      </p>
      <h2>我們提供</h2>
      <p>
        友善的工作環境、學習旅宿營運的機會，以及在都蘭與自然、社區一起生活的日常。
      </p>
      <h2>目前招募</h2>
      {/* <h3>兼職人員</h3>
      <p>時薪 NT$200，11:00–13:00，每週 2–3 天。</p> */}
      <h3>打工換宿</h3>
      <p>每天約工作4小時，每週休息2天，最少三週。</p>
      <div className="join-actions">
        <a className="outline-dark" href="/application">
          正職／兼職申請
        </a>
        <a className="outline-dark" href="/workforstay">
          打工換宿申請
        </a>
        <a className="text-link" href="/joinus-en">
          ENGLISH VERSION →
        </a>
      </div>
    </JoinPageLayout>
  );
}
